<template>
  <div :class="{
    'd-flex': true,
    'flex-row': $vuetify.breakpoint.lgAndDown,
    'flex-column': $vuetify.breakpoint.xs,
    'gap-h-20': $vuetify.breakpoint.smAndUp,
    'gap-v-20': $vuetify.breakpoint.xs,
  }">
    <v-tooltip bottom :disabled="!exportButtonRules.disabled">
      <template v-slot:activator="{ on, attrs }">
        <div v-on="on" v-bind="attrs">
          <v-btn v-if="exportButtonRules.show" :disabled="exportButtonRules.disabled" outlined color="primary"
            :style="btnAction.style" @click="openExportModal">
            <v-icon left>
              mdi-export-variant
            </v-icon>
            Exportar
          </v-btn>
        </div>
      </template>

      <span v-html="sanitize(invalidReprocessMessage)" />
    </v-tooltip>
    <v-menu transition="slide-y-transition" offset-y v-if="isRHProtegido">
      <template v-slot:activator="{ on, attrs }">
        <div v-on="on" v-bind="attrs">
          <v-btn class="white--text" color="primary" :style="btnAction.style" @click="">
            <v-icon left>
              mdi-cog-outline
            </v-icon>

            Ações em massa
          </v-btn>
        </div>
      </template>
      <TodoListActions :actions="loadMassActions()" :useSort="false" />
    </v-menu>
  </div>
</template>

<script>
import GenericFunctionsMixin from '@/shared/mixins/genericFunctions/genericFunctionsMixin';
import InvoicingMixin from '@/shared/mixins/invoicing/invoicingMixin';
import InvoicingRules from '@/components/Invoicing/rules/invoicingRules';
import TodoListActions from '@/components/TodoList/TodoListActions.vue';
import { mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  name: "InvoicingActions",

  components: {
    TodoListActions
  },

  mixins: [
    GenericFunctionsMixin,
    InvoicingMixin,
    InvoicingRules,
  ],

  computed: {
    ...mapGetters({
      isRHProtegido: 'user-info/isRHProtegido',
    })
  },

  methods: {
    ...mapActions({
      exportReport: 'invoicing/exportReport',
      requestReprocess: 'invoicing/requestReprocess',
    }),

    ...mapMutations({
      showExportRequestModal: 'invoicing/showExportRequestModal',
    }),

    async reprocessMajorities() {
      await this.requestReprocess()
        .then((result) => this.showMessage('success', 'Reprocessamento realizado!'))
        .catch((error) => {
          this.showMessage('error', 'Ocorreu um erro durante solicitação de reprocessamento!');
        });
    },

    showExportModal() {
      this.showExportRequestModal(true);
    },

    showMessage(statusMessage, message) {
      const invoicingSnackbar = this.invoicingViewReference()?.$refs.InvoicingSnackbar || false;

      invoicingSnackbar.open(
        statusMessage,
        message
      );
    },
    loadMassActions() {
      return [
        {
          label: 'Baixar todos os arquivos',
          icon: 'mdi mdi-tray-arrow-down',
          color: 'charcoal',
          condition: true,
          condition: this.hasPermission('sdi_invoicing_action_download_all_attachments'),
          // disabled: this.invoicesToValidate.length === 0,
          handler: () => console.log('downloadAll'),
        },
        {
          label: 'Baixar apenas arquivos selecionados',
          icon: 'mdi mdi-tray-arrow-down',
          color: 'charcoal',
          condition: true,
          condition: this.hasPermission('sdi_invoicing_action_download_selecteds_attachments'),
          // disabled: this.invoicesToValidate.length === 0,
          handler: () => console.log('downloadSelected'),
        },
      ];
    },
    openExportModal() {}
  }
}
</script>